import { RegularCartPrices } from "./RegularCartPrices";
import { TrialsPrices } from "./TrialsPrices";

type PricesProps = {
  isFreeTrial?: boolean;
  // FIXME: proper type
  prices: any;
  isSummary?: boolean;
  className?: string;
};

const Prices = ({ isFreeTrial = false, prices, isSummary = false, className }: PricesProps) => {
  if (prices) {
    if (!isFreeTrial) {
      return <RegularCartPrices prices={prices} isSummary={isSummary} className={className} />;
    }

    return <TrialsPrices {...prices} isSummary={isSummary} className={className} />;
  }

  return null;
};

export default Prices;
